import angular from 'angular';
import 'angular-bootstrap';
import './reviewsServices';

/* jshint -W055 */  // Disable warnings for constructor names not starting with uppercase (NgTableParams)
/* jshint -W106 */  // Disable warnings for non-camelCase identifiers (application_id, per_page, current_page)

const reviewsControllers = angular.module('applicationModule.reviewsControllers', ['applicationModule.reviewsServices', 'ui.bootstrap']);

reviewsControllers.controller('ReviewsListController', ['$scope', '$rootScope', '$state', '$stateParams', 'NgTableParams', 'Review', 'growl', 'AppsoupAPI', 'Permissions', function ($scope, $rootScope, $state, $stateParams, NgTableParams, Review, growl, AppsoupAPI, Permissions) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('reviews');
    $scope.application_id = $stateParams.application_id;

    $scope.tableParams = new NgTableParams(AppsoupAPI.getRatiNgTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return Review.getList($scope.application_id, params._params)
                .then(function (response) {
                    if (angular.isDefined(response)) {
                        params.total(response.total);
                        params.count(response.per_page);
                        params.page(response.current_page);
                        return response.data;
                    }
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });
    $scope.reviewRefuse = function (reviewId, status, index) {
        Review.setStatus(reviewId, status)
            .then(function (response) {
                $scope.tableParams.data[index].status = response.status;
                if (response.status) {
                    growl.success('MODULES.REVIEWS.MESSAGE.ACTIVE');
                } else {
                    growl.success('MODULES.REVIEWS.MESSAGE.INACTIVE');
                }
            });
    };
}]);

reviewsControllers.controller('AbuseListController', ['$scope', '$state', '$stateParams', 'Review', function ($scope, $state, $stateParams, Review) {
    'use strict';
    $scope.reviewId = $stateParams.reviewId;
    Review.getAbuse($scope.reviewId)
        .then(function (response) {
            if (response) {
                $scope.abuse = response;
            } else {
                $scope.abuse = {};
            }
        });
    $scope.back = function () {
        $state.go('appsoup.application.reviews');
    };
}]);

export default reviewsControllers;
